import * as React from 'react';

const PageLayout = ({ children , bottomContainerSlot ,  })=>{
    return /*#__PURE__*/ React.createElement(React.Fragment, null, children, /*#__PURE__*/ React.createElement("div", {
        className: "returns-bottom-container"
    }, bottomContainerSlot));
};

export { PageLayout as default };
//# sourceMappingURL=PageLayout.js.map
